import { render, staticRenderFns } from "./Loading_1.vue?vue&type=template&id=5dd81e42&scoped=true&"
import script from "./Loading_1.vue?vue&type=script&lang=js&"
export * from "./Loading_1.vue?vue&type=script&lang=js&"
import style0 from "./Loading_1.vue?vue&type=style&index=0&id=5dd81e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd81e42",
  null
  
)

export default component.exports